export { getPredictedRevenueFromProtection } from './getPredictedRevenueFromProtection'
